import React from 'react';
import constants from 'Constants';


export default class FacebookSdk extends React.Component {
  constructor (props) {
    super(props);
  }

  componentDidMount() {
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = `//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v5.0&appId=${constants.FACEBOOK_APP_ID}`;
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

  render() {
    return (
      <div id="fb-root"></div>
    );
  }
}




